import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const removeCommentThread: YJSChangeHandler<
  DatabaseChangeType.REMOVE_VALUE_COMMENT_THREAD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.removeCommentThread(`${change.entryId}-${change.fieldId}`, change.threadId);
  });
};
